// Datenschutzerklärung – editable content. Items with `confirm` must be checked by the owner.
// Review mode: open /datenschutz?pruefen=1 to highlight all points that still need confirmation.

export const PRIVACY_UPDATED = { de: "Stand: Juni 2026", en: "Last updated: June 2026" };

export const privacy = {
  de: [
    {
      title: "1. Verantwortliche Stelle",
      paragraphs: [
        "Verantwortlich für die Bearbeitung von Personendaten auf dieser Website ist: Alpha – Watch Kristian Yukhan, Brandschenkestrasse 6, 8001 Zürich, Schweiz. Telefon: +41 76 377 07 43, E-Mail: alphawatch.kristian@gmail.com.",
        "Bei Fragen zum Datenschutz oder zur Geltendmachung Ihrer Rechte können Sie uns jederzeit über diese Kontaktdaten erreichen.",
      ],
    },
    {
      title: "2. Grundsätze und Rechtsgrundlagen",
      paragraphs: [
        "Wir bearbeiten Personendaten im Einklang mit dem Schweizer Bundesgesetz über den Datenschutz (DSG) und der zugehörigen Verordnung (DSV). Soweit die EU-Datenschutz-Grundverordnung (DSGVO) anwendbar ist – etwa bei Besucherinnen und Besuchern aus der EU –, berücksichtigen wir auch deren Vorgaben.",
        "Rechtsgrundlagen nach DSGVO sind je nach Bearbeitung: Ihre Einwilligung (Art. 6 Abs. 1 lit. a), die Bearbeitung von Anfragen und Verträgen (Art. 6 Abs. 1 lit. b) sowie unser berechtigtes Interesse am sicheren und funktionsfähigen Betrieb der Website (Art. 6 Abs. 1 lit. f).",
      ],
    },
    {
      title: "3. Hosting und Server-Logfiles",
      paragraphs: [
        "Diese Website wird über die Plattform Emergent (Emergent Labs) bereitgestellt. Die Auslieferung erfolgt über das Netzwerk von Cloudflare. Beim Aufruf der Website werden technisch notwendige Daten verarbeitet, insbesondere IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, Referrer-URL, Browsertyp und Betriebssystem. Diese Daten dienen der Auslieferung, Stabilität und Sicherheit der Website.",
      ],
      confirm: [
        "Bitte bestätigen: Vertragspartner/Anbieter des Hostings (Emergent Labs, Sitz) sowie Serverstandorte und Speicherdauer der Logfiles gemäss den Angaben von Emergent.",
      ],
    },
    {
      title: "4. Cookies, lokale Speicherung und Einwilligung",
      paragraphs: [
        "Notwendige Speicherungen: Im lokalen Speicher Ihres Browsers (Local Storage) speichern wir Ihre Sprachauswahl und Ihre Cookie-Auswahl. Diese Angaben sind für den Betrieb erforderlich und werden nicht an Dritte übermittelt.",
        "Statistik- und Marketing-Dienste (Google Tag Manager, Google Analytics 4, Google Ads Conversion-Tracking, PostHog) werden erst geladen, nachdem Sie über unseren Cookie-Banner eingewilligt haben. Wählen Sie „Nur notwendige“, werden diese Dienste nicht geladen.",
        "Sie können Ihre Einwilligung jederzeit über den Link „Cookie-Einstellungen“ im Footer der Website ändern oder widerrufen. Nach einem Widerruf werden die betroffenen Dienste nicht mehr geladen und die von ihnen gesetzten Cookies im Browser gelöscht, soweit dies technisch möglich ist.",
      ],
    },
    {
      title: "5. Google Tag Manager",
      paragraphs: [
        "Wir verwenden den Google Tag Manager (Anbieter für Nutzer in der Schweiz und EU: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland; Muttergesellschaft: Google LLC, USA). Der Tag Manager ist ein Werkzeug zur Verwaltung von Website-Tags. Er wird nur nach Ihrer Einwilligung in Statistik- oder Marketing-Cookies geladen. Dabei kann Ihre IP-Adresse an Google übermittelt werden. Die über den Tag Manager eingebundenen Dienste berücksichtigen Ihre Einwilligung über den Google-Einwilligungsmodus (Consent Mode).",
      ],
    },
    {
      title: "6. Google Analytics 4",
      paragraphs: [
        "Mit Ihrer Einwilligung in Statistik-Cookies nutzen wir Google Analytics 4 (Google Ireland Limited / Google LLC), um die Nutzung unserer Website auszuwerten, z. B. aufgerufene Seiten, Verweildauer, ungefährer Standort (Land/Stadt), Gerätetyp sowie Klicks auf Kontakt-Links (WhatsApp, Telefon, E-Mail, Chrono24). Google Analytics 4 speichert IP-Adressen nach Angaben von Google nicht. Dazu werden Cookies (z. B. „_ga“) gesetzt.",
      ],
      confirm: [
        "Bitte bestätigen: In Google Analytics eingestellte Aufbewahrungsdauer der Daten (2 oder 14 Monate) sowie, ob Google-Signale oder eine Verknüpfung mit Google Ads aktiviert sind.",
      ],
    },
    {
      title: "7. Google Ads und Conversion-Tracking",
      paragraphs: [
        "Mit Ihrer Einwilligung in Marketing-Cookies nutzen wir Google Ads Conversion-Tracking (Google Ireland Limited / Google LLC). Damit messen wir, ob Besucherinnen und Besucher, die über eine Google-Anzeige auf unsere Website gelangt sind, uns kontaktieren (Klick auf WhatsApp, Telefon oder E-Mail). Dazu können Cookies (z. B. „_gcl_au“) gesetzt werden. Wir erhalten von Google nur zusammengefasste Statistiken, die keine Identifikation einzelner Personen ermöglichen.",
      ],
      confirm: [
        "Bitte bestätigen: Ob Google Ads aktiv genutzt wird und ob zusätzlich Remarketing / personalisierte Werbung eingesetzt wird (falls ja, muss dies hier ergänzt werden).",
      ],
    },
    {
      title: "8. PostHog (Statistik, Sitzungsaufzeichnung und Heatmaps)",
      paragraphs: [
        "Mit Ihrer Einwilligung in Statistik-Cookies verwenden wir PostHog (PostHog Inc., USA; Datenverarbeitung über Server in den USA, us.i.posthog.com). PostHog erfasst die Nutzung der Website, einschliesslich Seitenaufrufen, Klicks, Mausbewegungen und Scrollverhalten, und kann Sitzungen in Form von Aufzeichnungen (Session Recording) sowie Heatmaps darstellen. Dabei werden technische Daten wie IP-Adresse, Browser- und Geräteinformationen verarbeitet. PostHog setzt Cookies bzw. Einträge im Local Storage (Präfix „ph_“).",
      ],
      confirm: [
        "Bitte bestätigen: Das eingebundene PostHog-Projekt wird von der Plattform Emergent bereitgestellt. Bitte klären Sie, wer Zugriff auf diese Daten hat, ob Eingabefelder in Aufzeichnungen maskiert werden und wie lange die Daten gespeichert werden.",
      ],
    },
    {
      title: "9. Emergent Plattform-Skript",
      paragraphs: [
        "Auf der Website wird ein technisches Skript der Plattform Emergent (assets.emergent.sh) geladen, über die diese Website erstellt und betrieben wird. Dabei wird Ihre IP-Adresse an den Anbieter übermittelt.",
      ],
      confirm: [
        "Bitte bestätigen: Zweck und Datenverarbeitung dieses Skripts gemäss Angaben von Emergent (z. B. ob es nur technische Funktionen erfüllt oder ebenfalls Nutzungsdaten erfasst).",
      ],
    },
    {
      title: "10. Schriftarten",
      paragraphs: [
        "Die auf dieser Website verwendeten Schriftarten (Cormorant Garamond, Outfit) werden lokal von unserem eigenen Webserver geladen. Es wird dafür keine Verbindung zu Servern von Google Fonts hergestellt.",
      ],
    },
    {
      title: "11. Kontakt per WhatsApp, Telefon und E-Mail",
      paragraphs: [
        "Auf unserer Website gibt es kein Kontaktformular. Sie können uns per WhatsApp, Telefon oder E-Mail kontaktieren. Die von Ihnen übermittelten Angaben (z. B. Name, Telefonnummer, E-Mail-Adresse, Inhalt Ihrer Anfrage, ggf. Fotos Ihrer Uhr oder Ihres Schmuckstücks) bearbeiten wir ausschliesslich zur Beantwortung Ihrer Anfrage und zur Abwicklung eines allfälligen Auftrags.",
        "WhatsApp: Beim Klick auf einen WhatsApp-Button werden Sie zu WhatsApp weitergeleitet (WhatsApp Ireland Limited bzw. Meta Platforms, Inc., USA). Für die Datenbearbeitung durch WhatsApp gelten dessen Datenschutzbestimmungen. Wir empfehlen, uns keine besonders schützenswerten Daten über WhatsApp zu senden. Alternativ erreichen Sie uns per Telefon oder E-Mail.",
        "E-Mail: Für unsere E-Mail-Adresse nutzen wir den Dienst Gmail von Google.",
      ],
      confirm: [
        "Bitte bestätigen: Wie lange Sie Anfragen per WhatsApp/E-Mail aufbewahren (z. B. bis zum Abschluss der Anfrage oder gemäss gesetzlicher Aufbewahrungspflichten von 10 Jahren für Geschäftsunterlagen).",
      ],
    },
    {
      title: "12. Links zu externen Websites (Chrono24)",
      paragraphs: [
        "Unser Katalog verweist auf unseren Shop bei Chrono24 (Chrono24 GmbH, Deutschland). Erst wenn Sie den Link anklicken, werden Sie zu Chrono24 weitergeleitet; dort gelten die Datenschutzbestimmungen von Chrono24.",
      ],
    },
    {
      title: "13. Datenübermittlung ins Ausland",
      paragraphs: [
        "Einige der genannten Anbieter haben ihren Sitz in den USA oder bearbeiten Daten dort (Google LLC, PostHog Inc., Meta Platforms Inc., Cloudflare Inc. sowie der Anbieter der Plattform Emergent). Eine Übermittlung in die USA erfolgt, soweit der Anbieter unter dem Swiss-U.S. bzw. EU-U.S. Data Privacy Framework zertifiziert ist, auf dieser Grundlage, andernfalls auf Basis von Standardvertragsklauseln oder Ihrer Einwilligung. Bei Diensten, die nur nach Einwilligung geladen werden, erfolgt die Übermittlung erst nach Ihrer Einwilligung.",
      ],
      confirm: [
        "Bitte bestätigen: Ob die jeweiligen Anbieter (insbesondere PostHog und Emergent) unter dem Data Privacy Framework zertifiziert sind bzw. Standardvertragsklauseln anbieten, und ob mit ihnen ein Auftragsbearbeitungsvertrag besteht.",
      ],
    },
    {
      title: "14. Speicherdauer",
      paragraphs: [
        "Wir bewahren Personendaten nur so lange auf, wie es für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Ihre Cookie-Auswahl bleibt in Ihrem Browser gespeichert, bis Sie diese ändern oder den Browserspeicher löschen.",
      ],
    },
    {
      title: "15. Ihre Rechte",
      paragraphs: [
        "Sie haben im Rahmen des DSG insbesondere das Recht auf Auskunft über Ihre Personendaten, auf Berichtigung unrichtiger Daten, auf Löschung bzw. Einschränkung der Bearbeitung, auf Widerspruch gegen bestimmte Bearbeitungen sowie auf Herausgabe oder Übertragung Ihrer Daten. Soweit die DSGVO anwendbar ist, stehen Ihnen die entsprechenden Rechte gemäss Art. 15–21 DSGVO zu. Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.",
        "Zur Ausübung Ihrer Rechte genügt eine Nachricht an die oben genannten Kontaktdaten. Sie haben zudem das Recht, sich beim Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten (EDÖB, www.edoeb.admin.ch) bzw. bei einer zuständigen Aufsichtsbehörde in der EU zu beschweren.",
      ],
    },
    {
      title: "16. Datensicherheit",
      paragraphs: [
        "Diese Website wird verschlüsselt über HTTPS übertragen. Wir treffen angemessene technische und organisatorische Massnahmen, um Ihre Daten vor Verlust und unbefugtem Zugriff zu schützen.",
      ],
    },
    {
      title: "17. Änderungen",
      paragraphs: [
        "Wir können diese Datenschutzerklärung jederzeit anpassen, etwa wenn wir neue Dienste einsetzen. Es gilt die jeweils auf dieser Website veröffentlichte Fassung.",
      ],
    },
  ],
  en: [
    {
      title: "1. Controller",
      paragraphs: [
        "The controller responsible for processing personal data on this website is: Alpha – Watch Kristian Yukhan, Brandschenkestrasse 6, 8001 Zurich, Switzerland. Phone: +41 76 377 07 43, e-mail: alphawatch.kristian@gmail.com.",
        "This English version is provided for convenience; in case of doubt the German version prevails.",
      ],
    },
    {
      title: "2. Principles and legal bases",
      paragraphs: [
        "We process personal data in accordance with the Swiss Federal Act on Data Protection (FADP). Where the EU General Data Protection Regulation (GDPR) applies, e.g. for visitors from the EU, we also comply with its requirements. Legal bases under the GDPR are your consent (Art. 6(1)(a)), handling of inquiries and contracts (Art. 6(1)(b)) and our legitimate interest in a secure, functional website (Art. 6(1)(f)).",
      ],
    },
    {
      title: "3. Hosting and server logs",
      paragraphs: [
        "This website is provided via the Emergent platform (Emergent Labs) and delivered through the Cloudflare network. When you visit the website, technically necessary data is processed, in particular IP address, date and time, page visited, referrer URL, browser type and operating system, to deliver the website and keep it stable and secure.",
      ],
      confirm: ["To be confirmed: hosting provider details, server locations and log retention period according to Emergent."],
    },
    {
      title: "4. Cookies, local storage and consent",
      paragraphs: [
        "Necessary storage: we store your language and cookie choice in your browser's local storage. This is required for operation and not shared with third parties.",
        "Statistics and marketing services (Google Tag Manager, Google Analytics 4, Google Ads conversion tracking, PostHog) are only loaded after you consent via our cookie banner. If you choose “Necessary only”, these services are not loaded. You can change or withdraw your consent at any time via “Cookie settings” in the footer.",
      ],
    },
    {
      title: "5. Google Tag Manager",
      paragraphs: [
        "We use Google Tag Manager (Google Ireland Limited, Dublin, Ireland; parent company Google LLC, USA) to manage website tags. It is only loaded after your consent to statistics or marketing cookies; your IP address may be transmitted to Google. Tags respect your choice via Google Consent Mode.",
      ],
    },
    {
      title: "6. Google Analytics 4",
      paragraphs: [
        "With your consent to statistics cookies we use Google Analytics 4 to analyse website usage (pages viewed, duration, approximate location, device type and clicks on contact links). According to Google, GA4 does not store IP addresses. Cookies such as “_ga” are set.",
      ],
      confirm: ["To be confirmed: data retention set in Google Analytics (2 or 14 months) and whether Google signals or Google Ads linking are enabled."],
    },
    {
      title: "7. Google Ads and conversion tracking",
      paragraphs: [
        "With your consent to marketing cookies we use Google Ads conversion tracking to measure whether visitors arriving via a Google ad contact us (click on WhatsApp, phone or e-mail). Cookies such as “_gcl_au” may be set. We only receive aggregated statistics.",
      ],
      confirm: ["To be confirmed: whether Google Ads is actively used and whether remarketing / personalised advertising is used."],
    },
    {
      title: "8. PostHog (analytics, session recording and heatmaps)",
      paragraphs: [
        "With your consent to statistics cookies we use PostHog (PostHog Inc., USA; servers in the USA). PostHog records website usage including page views, clicks, mouse movements and scrolling and may provide session recordings and heatmaps. Technical data such as IP address, browser and device information is processed. PostHog uses cookies / local storage entries (prefix “ph_”).",
      ],
      confirm: ["To be confirmed: the PostHog project is provided by the Emergent platform – who has access, whether inputs are masked and how long data is kept."],
    },
    {
      title: "9. Emergent platform script",
      paragraphs: [
        "A technical script of the Emergent platform (assets.emergent.sh), on which this website is built and operated, is loaded. Your IP address is transmitted to the provider.",
      ],
      confirm: ["To be confirmed: purpose and data processing of this script according to Emergent."],
    },
    {
      title: "10. Fonts",
      paragraphs: ["The fonts used (Cormorant Garamond, Outfit) are served locally from our own web server. No connection to Google Fonts servers is made."],
    },
    {
      title: "11. Contact via WhatsApp, phone and e-mail",
      paragraphs: [
        "There is no contact form on this website. You can contact us via WhatsApp, phone or e-mail. The information you provide (e.g. name, phone number, e-mail, content of your inquiry, photos of your watch or jewellery) is used solely to answer your inquiry and process any order.",
        "WhatsApp: clicking a WhatsApp button redirects you to WhatsApp (WhatsApp Ireland Limited / Meta Platforms, Inc., USA); WhatsApp's privacy policy applies. Alternatively, contact us by phone or e-mail. For our e-mail address we use Google's Gmail service.",
      ],
      confirm: ["To be confirmed: how long inquiries via WhatsApp/e-mail are kept."],
    },
    {
      title: "12. External links (Chrono24)",
      paragraphs: ["Our catalogue links to our shop on Chrono24 (Chrono24 GmbH, Germany). Only when you click the link are you redirected to Chrono24, where its privacy policy applies."],
    },
    {
      title: "13. Transfers abroad",
      paragraphs: [
        "Some providers are based in or process data in the USA (Google LLC, PostHog Inc., Meta Platforms Inc., Cloudflare Inc. and the provider of the Emergent platform). Transfers are based on the Swiss-U.S. / EU-U.S. Data Privacy Framework where the provider is certified, otherwise on standard contractual clauses or your consent. For consent-based services, transfers only take place after your consent.",
      ],
      confirm: ["To be confirmed: certification / standard contractual clauses and data processing agreements for each provider (in particular PostHog and Emergent)."],
    },
    {
      title: "14. Retention",
      paragraphs: ["We keep personal data only as long as necessary for the purposes stated or as required by law. Your cookie choice remains stored in your browser until you change it or clear your browser storage."],
    },
    {
      title: "15. Your rights",
      paragraphs: [
        "Under the FADP you have in particular the right to access, rectification, erasure or restriction, objection and data portability; where the GDPR applies, the rights under Art. 15–21 GDPR. You can withdraw consent at any time with effect for the future. Simply contact us using the details above. You may also lodge a complaint with the Swiss Federal Data Protection and Information Commissioner (FDPIC, www.edoeb.admin.ch) or a competent EU supervisory authority.",
      ],
    },
    {
      title: "16. Security and changes",
      paragraphs: [
        "This website is transmitted encrypted via HTTPS. We take appropriate technical and organisational measures to protect your data. We may update this privacy policy at any time; the version published on this website applies.",
      ],
    },
  ],
};
